/**
 * @param {unknown} [owner]
 */
export function makeOwner(owner) {
  return {
    name: 'inner owner',
    /**
     * @param {string} name
     */
    lookup(name) {
      if (typeof owner !== 'object') return;
      if (!owner) return;
      if (!('lookup' in owner)) return;
      if (typeof owner.lookup !== 'function') return;

      return owner.lookup(name);
    },
    /**
     * @param {string} name
     */
    resolveRegistration(name) {
      if (typeof owner !== 'object') return;
      if (!owner) return;
      if (!('resolveRegistration' in owner)) return;
      if (typeof owner.resolveRegistration !== 'function') return;

      return owner.resolveRegistration(name);
    },

    /**
     * @param {string} name
     */
    hasRegistration(name) {
      if (typeof owner !== 'object') return;
      if (!owner) return;
      if (!('hasRegistration' in owner)) return;
      if (typeof owner.hasRegistration !== 'function') return;

      return owner.hasRegistration(name);
    },

    /**
     * @param {string} name
     */
    factoryFor(name) {
      if (typeof owner !== 'object') return;
      if (!owner) return;
      if (!('factoryFor' in owner)) return;
      if (typeof owner.factoryFor !== 'function') return;

      return owner.factoryFor(name);
    },
  };
}
